import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { VaLink } from '@department-of-veterans-affairs/component-library/dist/react-bindings';

import { isLOA3, isLoggedIn } from 'platform/user/selectors';
import { IntroductionPageView } from '../../shared/components/IntroductionPageView';
import { FORM_10_8678 } from '../definitions/constants';

const ombInfo = {
  resBurden: '10',
  ombNumber: '2900-0198',
  expDate: '06/30/2029',
};

const { INTRODUCTION: I } = FORM_10_8678;

const getStartPageHref = route => {
  const firstFormPage = route?.pageList?.find(
    page => page?.path && page.path !== 'introduction',
  );

  if (!firstFormPage?.path) {
    return window.location.pathname;
  }

  const basePath = window.location.pathname.replace(/\/introduction\/?$/, '');
  const pagePath = firstFormPage.path.startsWith('/')
    ? firstFormPage.path
    : `/${firstFormPage.path}`;

  return `${basePath}${pagePath}`;
};

const createPrimaryEntryStartLink = startPageHref => {
  const PrimaryEntryStartLink = ({ children, onClick }) => (
    <va-link-action
      href={startPageHref}
      onClick={onClick}
      text={children}
      type="primary-entry"
    />
  );

  PrimaryEntryStartLink.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  return PrimaryEntryStartLink;
};

export const IntroductionPage = ({ route, userIdVerified, userLoggedIn }) => {
  const content = {
    formTitle: I.FORM_TITLE,
    formSubTitle: I.FORM_SUBTITLE,
    authStartFormText: I.AUTH_START_FORM_TEXT,
    saveInProgressText: I.SAVE_IN_PROGRESS_TEXT,
    displayNonVeteranMessaging: true,
    hideSipIntro: userLoggedIn && !userIdVerified,
    customLink: createPrimaryEntryStartLink(getStartPageHref(route)),
  };

  const childContent = (
    <>
      <div className="vads-u-margin-top--3 vads-u-margin-bottom--3">
        <p className="va-introtext">{I.INTRO}</p>
      </div>

      <section>
        <h2>{I.GET_STARTED_TITLE}</h2>
        <va-process-list>
          <va-process-list-item header={I.STEP_ELIGIBILITY_TITLE} level={3}>
            <p>{I.STEP_ELIGIBILITY_INTRO}</p>

            <p>
              <VaLink
                href={I.STEP_ELIGIBILITY_LINK}
                text={I.STEP_ELIGIBILITY_LINK_TEXT}
              />
            </p>

            <p>
              <strong>{I.STEP_ELIGIBILITY_NOTE}</strong>{' '}
              {I.STEP_ELIGIBILITY_NOTE_TEXT}
            </p>
          </va-process-list-item>

          <va-process-list-item header={I.STEP_GATHER_TITLE} level={3}>
            <p>{I.STEP_GATHER_INTRO}</p>
            <ul>
              {I.STEP_GATHER_BULLETS.map(item => (
                <li key={item.label}>
                  <strong>{item.label}:</strong> {item.body}
                </li>
              ))}
            </ul>
          </va-process-list-item>

          <va-process-list-item header={I.STEP_START_TITLE} level={3}>
            <p>{I.STEP_START_BODY}</p>
            <p>{I.STEP_START_FOLLOWUP}</p>

            <va-additional-info trigger={I.AFTER_APPLY_TITLE}>
              <p>{I.AFTER_APPLY_DECISION}</p>
              <p>{I.AFTER_APPLY_NO_LETTER}</p>
              <p>
                {I.AFTER_APPLY_NO_LETTER_P1}{' '}
                <va-telephone contact={I.AFTER_APPLY_PHONE_NUMBER} /> ({' '}
                <va-telephone contact={I.AFTTER_APPLY_TTY_NUMBER} tty />
                ).
                {I.AFTER_APPLY_NO_LETTER_P2}
              </p>
            </va-additional-info>
          </va-process-list-item>
        </va-process-list>
      </section>
    </>
  );

  return (
    <IntroductionPageView
      route={route}
      content={content}
      ombInfo={ombInfo}
      childContent={childContent}
      devOnly={{
        forceShowFormControls: true,
      }}
    />
  );
};

IntroductionPage.propTypes = {
  route: PropTypes.shape({
    formConfig: PropTypes.shape({
      prefillEnabled: PropTypes.bool,
      savedFormMessages: PropTypes.shape({}),
    }),
    pageList: PropTypes.array,
  }),
  userIdVerified: PropTypes.bool,
  userLoggedIn: PropTypes.bool,
};

const mapStateToProps = state => ({
  userIdVerified: isLOA3(state),
  userLoggedIn: isLoggedIn(state),
});

export default connect(mapStateToProps)(IntroductionPage);
